import { Mapper } from "../../../../base/utils/mapper";
import { KerotometryResponseModel } from "../../../../domain/models/consult/kerotometry-response.model";
import { KerotometryResponseEntity } from "../entities/kerotometry-response.entity";

export class KerotometryImplementationRepositoryMapper extends Mapper<KerotometryResponseEntity, KerotometryResponseModel> {
    mapFrom(param: KerotometryResponseEntity): KerotometryResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: KerotometryResponseModel): KerotometryResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}